<template>
  <div id="app">
    <div class="body fixed mobile wheel-game">
      <!-- class: fixed, mobile -->
      <!-- Loading Spinner -->
      <!-- <div class="spinner"><div><div></div></div></div> -->
      <!-- Header -->
      <section class="header point_success">
        <div class="flexH">
          <a
            class="icon iconButton third"
            @click.prevent="goBackTo"
          >
            <font-awesome-icon
              icon="fa-solid fa-chevron-left"
              size="lg"
            ></font-awesome-icon>
          </a>
        </div>
        <span class="fL nowrap">小遊戲</span>
        <div class="flexH hide-opacity">
          <font-awesome-icon
            icon="fa-solid fa-chevron-left"
            size="lg"
          ></font-awesome-icon>
        </div>
        <span class="fM reward-text" @click="toRewardDetail">抽獎結果</span>
      </section>
      <!-- Main -->
      <div class="main-section-wrapper">
        <section class="main point_success items-center main-section">
          <img class="bg" src="@/assets/icon/bg_minigame.png" />
          <Roulette
            v-if="items.length > 0"
            class="mt-4"
            ref="wheel"
            base-display
            centered-indicator
            display-indicator
            display-border
            :display-shadow="false"
            :items="items"
            :first-item-index="firstIdx"
            :wheel-result-index="wheelResultIndex"
            @wheel-end="onWheelEnd"
          >
            <template #baseContent>
              <img width="100" src="@/assets/icon/uide/coin.svg" alt="" />
            </template>
          </Roulette>
          <button v-if="isCampaignsLoaded" class="click-btn button text-white fM border-0 mt-4" :disabled="drawDisabled" @click="startGame">
            開始抽獎
          </button>
          <p class="can-draw-count" v-if="isRegular">
            <span>可抽獎次數</span>
            <span class="hit-text">{{ drawTimes }}</span>
            <span>次</span>
          </p>
          <p v-if="isRegular && drawTimes <= 0" class="no-draw-text">抱歉，您暫無抽獎資格，可藉由完成任務來增加您的抽獎次數！</p>
        </section>
      </div>
    </div>
    <ConfirmDialog
      ref="resultDialogRef"
      :type="dialogInfo.type"
      :title="dialogInfo.title"
      :content="dialogInfo.content"
      :buttons="dialogInfo.buttons"
    />
    <AlertDialog
      v-if="showAlert"
      :title="alert.title"
      :content="alert.message"
      @close="onCloseAlertDialog"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";

import Roulette from "../components/Roulette.vue";
import ConfirmDialog from '@/components/Dialog/ConfirmDialog.vue'
import AlertDialog from '@/components/Dialog/AlertDialog.vue'

export default {
  name: "WheelGame",
  components: {
    Roulette,
    ConfirmDialog,
    AlertDialog
  },
  data() {
    return {
      apiHost: process.env.VUE_APP_API_HOST,
      merchantId: process.env.VUE_APP_MERCHANT_ID,
      firstIdx: { value: 0 },
      wheelResultIndex: { value: 2 },
      drawing: false,
      isCampaignsLoaded: false,
      resultTitle: "感謝您中獎",
      dialogInfo: {},
      showAlert: false,
      alert: {
        title: '',
        message: ''
      },
      backToHome: false,
      // items: [
      //   {
      //     id: 1,
      //     name: "Banana",
      //     htmlContent: "Banana",
      //     textColor: "",
      //     background: "",
      //   },
      //   {
      //     id: 2,
      //     name: "Apple",
      //     htmlContent: "Apple",
      //     textColor: "",
      //     background: "",
      //   },
      //   {
      //     id: 3,
      //     name: "Orange and Purple",
      //     htmlContent: "Orange<br>and Purple",
      //     textColor: "",
      //     background: "",
      //   },
      //   {
      //     id: 4,
      //     name: "Cherry",
      //     htmlContent: "Cherry",
      //     textColor: "",
      //     background: "",
      //   },
      // ],
      campaign: {},
      init: false,
      lastRewardStatus: null
    };
  },
  computed: {
    ...mapState(["user", "userInfo"]),
    isRegular() {
      return this.campaign?.campaignPrototype === "minigame-regular";
    },
    drawTimes() {
      return this.campaign?.draw_times || 0;
    },
    drawDisabled() {
      if (!this.isCampaignsLoaded) {
        return true;
      }
      if (this.isRegular) {
        return this.drawing || this.drawTimes <= 0;
      }
      return this.drawing || this.campaign.reward_status;
    },
    items() {
      const missions = JSON.parse(
        JSON.stringify(this.campaign?.missions || [])
      );
      // if (missions.length > 0 && missions.length < 4) {
      //   for (let i = missions.length; i < 4; i++) {
      //     missions.push({
      //       missionName: "銘謝惠顧",
      //     });
      //   }
      // }
      const re = missions?.map((m) => {
        return {
          id: m?.settings?.rewardId,
          name: m.missionName,
          htmlContent: m.missionName,
          textColor: "",
          background: "",
        };
      }) || [];
      return re
    },
    reward() {
      return this.items[this.wheelResultIndex.value];
    },
    resultContent() {
      return `恭喜您獲得 ${this.reward?.name}`;
    }
  },
  mounted() {
    this.getCampaigns();
  },
  methods: {
    onCloseAlertDialog() {
      this.showAlert = false;
      this.alert = {
        title: '',
        message: ''
      }

      if (this.backToHome) {
        this.$router.replace('/home')
      }
    },
    goBackTo() {
      this.$router.go(-1);
    },
    launchWheel() {
      this.$refs.wheel.launchWheel();
    },
    onWheelEnd() {
      if (!this.init) return this.init = true;

      const isWin = this.lastRewardStatus === 'success'
        && this.reward?.name
        && this.reward?.name !== '銘謝惠顧';

      if (isWin) {
        this.dialogInfo = {
          title: "恭喜您中獎",
          type: "success",
          content: `恭喜您獲得 ${this.reward?.name}`,
          buttons: [
            {
              text: "查看結果",
              outline: true,
              click: ({ close }) => {
                this.$router.push(`/campaign/${this.$route.params.id}/mini-game/reward`);
                close();
              },
            },
            {
              text: "確認",
              click: ({ close }) => {
                close();
              },
            },
          ],
        }
      } else {
        this.dialogInfo = {
          title: "沒有中獎",
          content: "下次再加油！",
          buttons: [
            {
              text: "確認",
              click: ({ close }) => {
                close();
              },
            },
          ],
        }
      }
      this.$refs.resultDialogRef.open()

      this.lastRewardStatus = null;
      this.getCampaigns(false)
      this.drawing = false
    },
    getCampaignAPI() {
      const apiHost = process.env.VUE_APP_API_HOST;
      const campaignId = this.$route.params.id;
      if (!apiHost || !this.user?.userId) return Promise.resolve({ data: { campaigns: [] } });
      let config = {
        url: `${apiHost}/campaigns/v1/merchants/${this.merchantId}/participations/${this.user.userId}`,
        method: "GET",
        params: {
          includeNonJoined: true,
          includeInactive: true,
          campaignId: campaignId,
          // 改走 core-apis 時弄丟的過濾條件（PR #64 review 指出）。
          //WARNING: 寫死 municipal 是還原舊站行為,不是新決定 —— 這支掛在
          //         /campaign/:id/mini-game,那條路由沒有 meta.publisher,
          //         所以拿不到路由推導值。專屬活動走這頁會撈不到自己的設定,
          //         那是遷移前就有的問題,不在這個 PR 處理。
          publisherType: 'municipal',
        }
      };
      return this.$http(config).then((res) => {
        return { data: { campaigns: (res.data.campaigns || []).map(c => this.mapCoreCampaign(c)) } };
      });
    },
    mapCoreCampaign(c) {
      const reward = c.rewards && c.rewards[0];
      const amount = reward ? parseInt(reward.context?.amount || 0) : 0;
      const inStock = reward ? reward.in_stock : null;
      const budget = c.campaignBudget;
      let rewardRemain = 0;
      let rewardTotal = 0;
      if (budget) {
        rewardTotal = Math.floor((budget.availablePoints + budget.usedPoints) / (amount || 1));
        rewardRemain = Math.floor(budget.availablePoints / (amount || 1));
      } else if (inStock !== null && inStock !== undefined) {
        rewardTotal = inStock;
        rewardRemain = inStock;
      }
      return {
        ...c,
        imageUrl: c.campaignImageUrl || '',
        reward_point: amount,
        reward_remain: rewardRemain,
        reward_total: rewardTotal,
        reward_status: c.hasCompleted,
        unread: false,
      };
    },
    getCampaigns(init = true) {
      this.getCampaignAPI()
        // this.campaignDummy()
        .then((res) => {
          const c = res.data.campaigns.find(
              (c) => c.campaignId === this.$route.params.id
            );
          if (init) {
            this.campaign = c
          } else {
            this.campaign.reward_status = c.reward_status
            this.campaign.draw_times = c?.draw_times || 0
          }

          console.log('this.campaign', this.campaign);
        })
        .finally(() => {
          this.isCampaignsLoaded = true;
        });
    },
    isOverToday(campaign) {
      const today = moment();
      const endTime = moment(campaign.campaignEndTime * 1000);
      return endTime.isBefore(today);
    },
    async startGame() {
      if (this.isOverToday(this.campaign)) {
        this.alert = {
          title: '提醒',
          message: '任務已下架'
        }
        this.showAlert = true
        this.backToHome = true
        return;
      }

      this.drawing = true
      this.init = true
      const swHost = process.env.VUE_APP_SW_API_HOST;
      const campaignId = this.$route.params.id;
      const missionId = this.campaign.missions?.[0]?.missionId;
      const config = {
        url: `${swHost}/api/campaigns/${campaignId}/missions/${missionId}/complete`,
        method: "POST",
        data: {
          uuid: this.user.userId,
          memberId: "",
        },
      };
      try {
        const res = await this.$http(config)
        const reward = res.data.reward;
        const rewardItem = Array.isArray(reward) ? reward[0] : reward;
        const status = rewardItem?.status;
        const rewardId = rewardItem?.rewardId;
        const isSuccess = status === 'success';
        const loseStatuses = ['no_stock', 'failed', 'budget_exceeded', 'error'];
        const isLose = loseStatuses.includes(status);

        this.lastRewardStatus = status;

        if (!isSuccess && !isLose) {
          this.drawing = false;
          this.alert = { title: '提醒', message: '抽獎發生問題，請稍後再試。' };
          this.showAlert = true;
          return;
        }

        let index = -1;
        if (isSuccess && rewardId) {
          //WARNING: 兩邊都要轉成字串再比。
          //         `i.id` 來自 mission settings,`rewardId` 來自完成任務的回應 ——
          //         一邊是數字、另一邊是字串時,`i.id === rewardId` 與
          //         `i.id === String(rewardId)` **兩個都是 false**(只轉了回應那一邊),
          //         於是 index < 0 走到未中獎分支:轉盤停在「銘謝惠顧」,
          //         但獎其實已經發出去了 —— 使用者被告知沒中獎
          //         (PR #64 review 第七輪指出)。
          index = this.items.findIndex(i => String(i.id) === String(rewardId));
        }

        // 未中獎：轉到隨機的「銘謝惠顧」格（同標品邏輯）
        if (isLose || index < 0) {
          const noRewardIndices = this.items.reduce((acc, item, i) => {
            if (item.name === '銘謝惠顧' || !item.id) acc.push(i);
            return acc;
          }, []);
          if (noRewardIndices.length > 0) {
            index = noRewardIndices[Math.floor(Math.random() * noRewardIndices.length)];
          } else {
            index = 0;
          }
        }

        this.wheelResultIndex.value = index;
        this.launchWheel()
      } catch (e) {
        this.drawing = false
        const errorCode = e.response?.data?.errorCode || '';
        const errorMessages = {
          'minigame-200': '你已經用完所有可玩的次數。',
          'minigame-201': '你已經用完今天可玩的次數，請明天再來。',
          'minigame-202': '你已經用完本週可玩的次數，請下週再來。',
          'minigame-203': '你已經用完本月可玩的次數，請下個月再來。',
          'minigame-204': '獎勵已發送完畢。',
          'minigame-205': '系統忙碌中，請稍後再試。',
        };
        const msg = errorMessages[errorCode] || e.response?.data?.message || e.response?.data?.result || '抽獎發生問題，請稍後再試。';
        this.alert = { title: '提醒', message: msg };
        this.showAlert = true;
      }
    },
    toRewardDetail() {
      this.$router.push(`/campaign/${this.$route.params.id}/mini-game/reward`)
    },
  },
};
</script>

<style scoped lang="scss">
.wheel-game {
  .main-section-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .main-section {
    position: relative;
    height: calc(100vh - 120px);
    margin: 0;
    width: 100%;
    padding-top: 80px;
    padding-bottom: 24px;
    justify-content: flex-start;
  }
  .bg {
    position: absolute;
    top: 16px;
    left: -16px;
    right: -16px;
    width: calc(100% + 32px);
    object-fit: contain;
  }
  .click-btn {
    width: 160px;
    margin-top: 36px;
    z-index: 1;
  }
}
.reward-text {
  color: #6B2DF5;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 !important;
}
.point_success {
  justify-content: space-between;
  position: relative;
}
.hide-opacity {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.hit-text {
  margin: 0 12px;
  color: var(--c1);
}
.can-draw-count {
  margin-top: 16px;
  font-weight: bold;
}
.no-draw-text {
  max-width: 280px;
  margin-top: 16px;
  color: #333333;
}
</style>
